var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event)?_c('EventComponent',{attrs:{"event":_vm.event}}):_c('div',{staticStyle:{"width":"100%"}},[_c('p',{staticClass:"my-4"},[_vm._v("You are in solo mode. Host an event to invite others.")]),_c('HostEventButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }